"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlanningFileType = void 0;
// Canonical planning-file-type catalogue. Reconciliation picked the
// DB-canonical naming: the 10 members actually present in the
// `public.planning_file_types` Hasura table (verified against
// `database/migrations/default/1675854248190_init/up.sql`).
//
// Backend pm/types previously declared 12 members with `*_ABF_SIGNED` naming
// (e.g. `PC_ABF_SIGNED`) — these names do NOT exist in the DB. The frontend
// enum already used the correct `*_SIGNED_ABF` naming (e.g. `PC_SIGNED_ABF`).
// TODO(#240-follow-up): backend's `routes/project-management.ts` builds the
// string `*_ABF_SIGNED` at runtime via concatenation (`+= '_ABF'; += '_SIGNED'`)
// and stores it via `acceptProject`. That construction is incompatible with
// the DB constraint and should be fixed in a separate issue. This migration
// preserves the existing runtime behaviour.
exports.PlanningFileType = {
    DP: 'DP',
    DP_ABF: 'DP_ABF',
    PC: 'PC',
    PC_ABF: 'PC_ABF',
    PC_SIGNED: 'PC_SIGNED',
    PC_SIGNED_ABF: 'PC_SIGNED_ABF',
    PCM: 'PCM',
    PCM_ABF: 'PCM_ABF',
    PCM_SIGNED: 'PCM_SIGNED',
    PCM_SIGNED_ABF: 'PCM_SIGNED_ABF',
};
//# sourceMappingURL=file-type.js.map